// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"e1a8fdb8","81":"11c81fcd","133":"6df9aa20","415":"20fefcc7","434":"655cd43e","787":"36716c49","815":"b8850dff","849":"f6c94ccd"}[chunkId] + ".chunk.js";
};